import React, { useState } from 'react';
import { Box, Button, Flex } from '@chakra-ui/react';
import TopTracks from './TopTracks';
import TopArtists from './TopArtists';

const Trending = () => {
    const [toggler, setToggler] = useState(false);

    return (
        <Box px={{base:"1rem",md:"2rem",lg:"2rem"}} borderRadius={3} m={4}>
            <Flex justifyContent="left" my={2} mx={2}>
                <Button
                    bg={!toggler ? "dark.900" : "dark.500"}
                    color={!toggler ? "dark.500" : "dark.900"}
                    variant="glassy"
                    onClick={() => setToggler(false)}
                    w={{base:"50%", lg:"8rem"}}
                    mr={2}

                >
                    Top Tracks
                </Button>
                <Button
                    bg={!toggler ? "dark.500" : "dark.900"}
                    color={!toggler ? "dark.900" : "dark.500"}
                    variant="glassy"
                    onClick={() => setToggler(true)}
                    w={{base:"50%", lg:"8rem"}}
                    ml={2}
                >
                    Top Artists
                </Button>
            </Flex>
            {toggler ? <TopArtists toggler={toggler}/> : <TopTracks toggler={toggler}/>}
        </Box>
    );
};

export default Trending;